import { getApps, initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: 'AIzaSyA92RvzUGM5Q6Gkuwa42wuk9exGEwBc47M',
  authDomain: 'kine-pi.firebaseapp.com',
  projectId: 'kine-pi',
  storageBucket: 'kine-pi.appspot.com',
  messagingSenderId: '530150688562',
  appId: '1:530150688562:web:cdaa89e96675d07fc6392b',
};

export const app = !getApps().length ? initializeApp(firebaseConfig) : getApps()[0];

export const auth = getAuth(app);
